import { PropsWithChildren } from 'react'
import { Container } from 'reactstrap';
import { useAuth } from '../context/AuthContext';
import { HeaderNavMenu } from './HeaderNavMenu';
import { Footer } from './Footer';
import { LockStatus } from './LockStatus';
import { styled } from '@uhg-abyss/web/tools/styled';

const ShellPage = styled('div', {
    display: 'flex',
    flexFlow: 'column',
    height: '100vh',
});

const ShellContent = styled(Container, {
    display: 'flex',
    flexFlow: 'column',
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 'auto',
    justifyContent: 'flex-start',
    alignItems: 'center',
});

export const Layout = (props: PropsWithChildren) => {
    const { isAuthenticated, isAuthError } = useAuth();

    return (
        <div>
            {
                isAuthenticated === true &&
                <ShellPage>
                    <HeaderNavMenu />
                    <ShellContent>
                        {props.children}
                    </ShellContent>
                    {!isAuthError &&
                        <LockStatus />
                    }
                    <Footer />
                </ShellPage>
            }
            {
                (window.location.pathname.toLowerCase() === '/logout' || window.location.pathname.toLowerCase() === '/loggedout') &&
                <ShellPage>
                    <HeaderNavMenu />
                    <ShellContent>
                        {props.children}
                    </ShellContent>
                    <Footer />
                </ShellPage>
            }
        </div>
    );
}
